export const matchPhone = (): { isIOS: boolean; isAndroid: boolean } => {
    const u = navigator.userAgent
    //ios终端
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || !!u.match(/\(M[^;]+;( U;)? Intel.+Mac OS X...*?iPad$/)
    //android终端
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    return {
        isIOS,
        isAndroid,
    }
}
